<template src="./module_2.html"></template>
<style src="./module_2.scss" lang="scss" scoped></style>

<script>
  import anime from 'animejs';
  import animations from '@/assets/js/animations';
  import * as contentful from 'contentful';

  import backgroundCharacters from './backgroundCharacters/backgroundCharacters'

  export default {
    data() {
      return {
        // reece and hailey blinking (duplicate of background characters logic)
        reeceData: {
          blinking: false
        },
        haileyData: {
          blinking: false
        },
        // modal
        modalActive: false,
        modalInd: 0,
        modalText: [
          [
            "Before you launch the animation, please assign the following speaking roles to students in the classroom. Readers will know it is their turn to speak when their character’s icon appears to the left of the text box.",
            "Student One: Aye", "Student Two: Ria"
          ]
        ],
        modalStyle: {
          'background': '#FACE86'
        },
        //
        lab_ready_state: {
          doors_active: true,
          doors_visible: true
        },
        school_doors: false,
        aye_state: ["smile", "green"],
        text: null,
        active_text: null,
        ria_speaking: false,
        ria_frown: false,
        ria_head_flip: false,
        control_panel_active: false,
        modal_active: false,
        module_complete: false,
        flying_robot_state: '',
        player1_state: {
          blinking: false,
          talking: false
        },
        player2_state: {
          blinking: false,
          talking: false,
          direction: 'left'
        },
        player3_state: {
          blinking: false,
          talking: false
        },
        pins_active: false,
        selected_pin: '',
        town_audio: new Audio('static/audio/module_2/urban_bg.mp3'),
        fountain_audio: new Audio('static/audio/module_2/fountain.wav'),
        car_audio: new Audio('static/audio/module_2/ill_beats.mp3'),
        pin_audio: new Audio('static/audio/module_2/blip.mp3'),
        couple_audio: new Audio('static/audio/module_2/couple_fighting.mp3')
      }
    },
    components: {
      'background-characters': backgroundCharacters
    },
    mounted() {

      // copypaste from backgroundCharacters.vue

      // random number generator
      const generateRandom = (min, max) => {
        return Math.random() * (max - min) + min;
      }

      // blinking animation
      const createBlinkAnimation = (data) => {
        setInterval(() => {
          data.blinking = true
          setTimeout(() => {
            data.blinking = false
          }, 300)
        }, generateRandom(6000, 8000)) // make random number
      }


      createBlinkAnimation(this.haileyData)
      createBlinkAnimation(this.reeceData)
      //

      // open initial modal
      this.modalActive = true

      this.town_audio.loop = true;
      // this.town_audio.play(); // moved to door open for safari.

      const content_client = contentful.createClient({
        space: process.env.SPACE_ID,
        accessToken: process.env.CMS_TOKEN
      });

      content_client.getEntries({
        content_type: 'module',
        'fields.module_number': 2
      }).then((response) => {
        this.text = response.items[0].fields.module_text.map((data) => {
          let temp;
          if (data.fields.speaker) {
            temp = {
              id: data.fields.id,
              speaker: data.fields.speaker,
              string: data.fields.text.replace(/\n/g, "<br/>")
            }
          } else {
            temp = {

              id: data.fields.id,
              string: data.fields.text.replace(/\n/g, "<br/>")
            }
          }
          return temp;
        });

        this.active_text = this.text[0];
      }).catch(console.error);

      anime(animations.fingerprint);

      anime({
        targets: '#fountain_1, #fountain_2, #fountain_3, #fountain_5, #fountain_6, #fountain_7',
        strokeDashoffset: (el) => {
          return [0, el.getTotalLength()];
        },
        duration: 4000,
        easing: 'linear',
        loop: true
      });

      anime({
        targets: '#fountain_4',
        strokeDashoffset: (el) => {
          return [el.getTotalLength(), 0];
        },
        duration: 4000,
        easing: 'linear',
        loop: true
      });

    },
    methods: {
      // close modal
      closeModal() {
        this.modalActive = false
      },
      //
      open_lab() {
        if (this.module_complete == false) {
          let new_id = this.text.indexOf(this.active_text) + 1;
          this.active_text = this.text[new_id];

          let door_sound = new Audio('static/audio/module_1/door_open.wav');
          door_sound.play();
          this.town_audio.play(); // safari fix

          anime({
            targets: '#lab_doors #left_door',
            translateX: '-100%',
            easing: 'easeOutQuart',
            duration: 2000,
            complete: () => {
              this.lab_ready_state.doors_active = false;
              this.lab_ready_state.doors_visible = false;
            }
          });

          anime({
            targets: '#lab_doors #right_door',
            translateX: '100%',
            duration: 2000,
            easing: 'easeOutQuart'
          });

          anime({
            targets: '#ria',
            translateY: [{
                value: '20px'
              },
              {
                value: '0'
              },
              {
                value: '20px'
              },
              {
                value: '0'
              }
            ],
            left: ['-20%', '10%'],
            easing: 'linear',
            duration: 2000
          });

          anime({
            targets: '#aye',
            translateY: [{
                value: '10px'
              },
              {
                value: '0'
              },
              {
                value: '10px'
              },
              {
                value: '0'
              }
            ],
            left: ['-20%', '0'],
            easing: 'linear',
            duration: 2000,
            complete: () => {
              this.control_panel_active = true;
            }
          });
        }
      },
      text_update() {
        let new_id = this.text.indexOf(this.active_text) + 1;
        if (this.text[new_id] && this.control_panel_active) {

          this.control_panel_active = false;
          this.active_text = this.text[new_id];

          if (this.active_text.speaker) {
            let current_speaker = this.active_text.speaker.toLowerCase();

            if (current_speaker == 'ria') {
              this.ria_speech(3, 500);
            }
          }

          let timeline = anime.timeline();

          console.log(new_id + 1);

          switch (new_id + 1) {
            case 3:
              // testing
              anime({
                targets: '#texter_left_arm_hand',
                rotate: ['0deg', '110deg', '110deg', '110deg', '110deg', '110deg', '110deg', '110deg', '110deg',
                  '110deg', '110deg', '110deg', '110deg', '0deg'
                ],
                easing: 'linear',
                duration: 10000,
                delay: 4000,
                loop: true
              })
              anime({
                targets: '#texter_left_pupil, #texter_right_pupil',
                translateY: ['0px', '0.5px', '0.5px', '0.5px', '0.5px', '0.5px', '0.5px', '0.5px', '0.5px', '0.5px',
                  '0.5px', '0.5px', '0.5px', '0px'
                ],
                easing: 'linear',
                duration: 10000,
                delay: 4000,
                loop: true
              })

              timeline.add({
                targets: '#ria',
                translateY: [{
                    value: '20px'
                  },
                  {
                    value: '0'
                  }
                ],
                left: ['10%', '20%'],
                easing: 'linear'
              }).add({
                targets: '#ria',
                scaleX: -1,
                duration: 1,
                easing: 'linear'
              }).add({
                targets: '#ria_left_arm_hand',
                rotate: '-90deg',
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_left_arm_hand',
                rotate: '-40deg',
                easing: 'easeOutCubic',
                delay: 1000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 4:
              this.control_panel_active = true;
              break;
            case 5:
              anime({
                targets: '#ria_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#aye_left_arm_hand',
                rotate: '-100deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 6:
              anime({
                targets: '#aye_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '-40deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 7:
              this.fountain_audio.loop = true;
              this.fountain_audio.volume = 0;
              this.fountain_audio.play();

              anime({
                targets: this.fountain_audio,
                volume: 0.35,
                easing: 'linear',
                duration: 8000
              });

              anime({
                targets: '#ria',
                scaleX: 1,
                duration: 1,
                easing: 'linear'
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#aye',
                translateY: 10,
                easing: 'linear',
                direction: 'alternate',
                duration: 650, // 500,
                loop: true
              });

              timeline.add({
                targets: '#aye',
                left: '10%',
                easing: 'easeOutCubic',
                complete: () => {

                  anime({
                    targets: '#ria',
                    translateY: 20,
                    easing: 'linear',
                    direction: 'alternate',
                    duration: 500,
                    loop: true
                  });

                  anime({
                    targets: '#town',
                    translateX: '-18%',
                    duration: 8000,
                    easing: 'linear',
                    complete: () => {
                      anime({
                        targets: '#hailey_left_arm_hand',
                        rotate: '-20deg',
                        easing: 'linear',
                        duration: 500
                      });

                      anime({
                        targets: '#reece_right_arm_hand',
                        rotate: '20deg',
                        easing: 'linear',
                        duration: 500
                      });

                      anime({
                        targets: '#reece_mouth_bottom',
                        translateY: [{
                            value: 1
                          },
                          {
                            value: 0
                          },
                          {
                            value: 1
                          },
                          {
                            value: 0
                          }
                        ],
                        easing: 'linear',
                        complete: () => {
                          anime({
                            targets: '#reece_mouth_bottom',
                            translateY: [{
                                value: 2
                              },
                              {
                                value: 0
                              },
                              {
                                value: 2
                              },
                              {
                                value: 0
                              }
                            ],
                            easing: 'linear',
                            delay: 5000,
                            loop: true
                          });
                        }
                      });

                      anime({
                        targets: '#hailey_mouth_bottom',
                        translateY: [{
                            value: 2
                          },
                          {
                            value: 0
                          },
                          {
                            value: 2
                          },
                          {
                            value: 0
                          }
                        ],
                        easing: 'linear',
                        delay: 5000,
                        loop: true
                      });

                      anime.remove('#ria, #aye');
                      this.control_panel_active = true;
                    }
                  });
                }
              }).add({
                targets: '#aye',
                left: 0,
                easing: 'linear'
              }).add({
                targets: '#ria',
                left: ['20%', '10%'],
                easing: 'linear',
                offset: '-=1000'
              });
              break;
            case 8:
              this.aye_state = ['neutral', 'yellow'];
              timeline.add({
                targets: '#aye_left_arm_hand, #aye_right_arm_hand',
                rotate: '-140deg',
                easing: 'easeOutCubic',
                duration: 700,
                complete: () => {
                  this.control_panel_active = true;
                }
              }).add({
                targets: '#aye_right_arm, #aye_left_arm',
                translateY: [{
                    value: -10
                  },
                  {
                    value: 0
                  }
                ],
                easing: 'linear',
                duration: 700
              });
              break;
            case 9:
              anime({
                targets: '#aye_left_arm_hand, #aye_right_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '-100deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 10:
              this.aye_state = ['neutral', 'green', 'head_scratch'];

              timeline.add({
                targets: '#aye_left_arm',
                rotate: '-140deg',
                easing: 'linear',
                duration: 500
              }).add({
                targets: '#aye_left_arm_hand',
                rotate: '-100deg',
                easing: 'easeOutCubic',
                duration: 700,
                offset: '-=100',
                complete: () => {
                  this.control_panel_active = true;
                }
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic',
              });
              break;
            case 11:
              anime({
                targets: '#aye_left_arm, #aye_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '-100deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 12:
              this.aye_state = ['smile', 'green'];

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 13:

              anime({
                targets: '#ria',
                translateY: 20,
                easing: 'linear',
                direction: 'alternate',
                duration: 500,
                loop: true
              });

              anime({
                targets: '#aye',
                translateY: 10,
                easing: 'linear',
                direction: 'alternate',
                duration: 650, // 500,
                loop: true
              });

              anime({
                targets: this.fountain_audio,
                volume: 0.1,
                easing: 'linear',
                duration: 5000
              });

              anime({
                targets: '#town',
                translateX: '-32%',
                easing: 'linear',
                duration: 5000,
                complete: () => {

                  this.players_idle(1);
                  setInterval(() => {
                    this.players_idle(1);
                  }, 10000);

                  setInterval(() => {
                    this.players_idle(2);
                  }, 4000);

                  setInterval(() => {
                    this.player2_head();
                  }, 10000);

                  setTimeout(() => {
                    setInterval(() => {
                      this.players_idle(3);
                    }, 10000);
                  }, 2000);

                  anime({
                    targets: '#player1_left_arm_hand',
                    rotate: '-20deg',
                    easing: 'linear'
                  });

                  setTimeout(() => {
                    anime({
                      targets: '#player1_left_arm_hand',
                      rotate: 0,
                      easing: 'linear'
                    });
                  }, 2000);

                  anime.remove('#ria, #aye');
                  this.control_panel_active = true;
                }
              });
              break;
            case 14:
              this.aye_state = ['neutral', 'yellow', 'head_scratch'];

              timeline.add({
                targets: '#aye_left_arm',
                rotate: '-45deg',
                easing: 'linear',
                duration: 300
              }).add({
                targets: '#aye_left_arm_hand',
                rotate: '-45deg',
                easing: 'easeOutCubic',
                duration: 500,
                offset: '-=100'
              }).add({
                targets: '#aye_left_arm, #aye_left_arm_hand',
                rotate: 0,
                easing: 'easeOutCubic',
                delay: 800,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 15:
              timeline.add({
                targets: '#ria_left_arm_hand',
                rotate: '-80deg',
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_left_arm_hand',
                rotate: 0,
                easing: 'easeOutCubic',
                delay: 1000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 16:
            case 17:
            case 18:
              this.aye_state = ['unsure', 'orange'];
              this.control_panel_active = true;
              break;
            case 19:
              this.aye_state = ['neutral', 'green'];
              this.car_audio.volume = 0;
              this.car_audio.loop = true;
              this.car_audio.play();

              anime({
                targets: this.car_audio,
                volume: 0.1,
                easing: 'linear',
                duration: 5000
              });

              anime({
                targets: '#car_body',
                translateY: [{
                    value: 5,
                    easing: 'linear',
                    duration: 200
                  },
                  {
                    value: 0
                  }
                ],
                duration: 2000,
                delay: 500,
                loop: true
              });

              anime({
                targets: '.car_music',
                opacity: [{
                    value: 1
                  },
                  {
                    value: 0
                  }
                ],
                translateY: -50,
                translateX: [{
                    value: 10
                  },
                  {
                    value: -10
                  }
                ],
                delay(el, i) {
                  return i * 500;
                },
                easing: 'linear',
                loop: true
              });

              anime({
                targets: this.fountain_audio,
                volume: 0,
                easing: 'linear',
                duration: 3000,
                complete: () => {
                  delete this.fountain_audio;
                  anime.remove('#fountain_1, #fountain_2, #fountain_3, #fountain_5, #fountain_6, #fountain_7');
                }
              });

              anime({
                targets: '#ria',
                translateY: [0, 20],
                easing: 'linear',
                direction: 'alternate',
                duration: 500,
                loop: true
              });

              anime({
                targets: '#aye',
                translateY: [0, 10],
                easing: 'linear',
                direction: 'alternate',
                duration: 500,
                loop: true
              });

              let ad = false;
              setInterval(() => {
                let ad_timeline = anime.timeline();

                if (ad) {
                  ad_timeline.add({
                    targets: '#ad_woman',
                    translateY: ['-100%', '0'],
                    easing: 'easeOutQuart'
                  }).add({
                    targets: '#ad_man',
                    translateY: ['0', '100%'],
                    easing: 'easeOutQuart',
                    offset: 0
                  });
                  ad = false;
                } else {
                  ad_timeline.add({
                    targets: '#ad_man',
                    translateY: ['-100%', '0'],
                    easing: 'easeOutQuart'
                  }).add({
                    targets: '#ad_woman',
                    translateY: ['0', '100%'],
                    easing: 'easeOutQuart',
                    offset: 0
                  });
                  ad = true;
                }
              }, 10000);

              anime({
                targets: '#town',
                translateX: '-48%',
                easing: 'linear',
                duration: 8000,
                complete: () => {
                  this.control_panel_active = true;
                  anime.remove('#ria, #aye');
                }
              });
              break;
            case 20:
              this.aye_state = ['neutral', 'red'];
              anime({
                targets: '#ria_left_arm_hand',
                rotate: '-45deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 21:
              setTimeout(() => { // added setTimeout to delay aye shutting down
                this.aye_state = ['grey', 'frown'];
                this.ria_frown = true;

                let shutdown_audio = new Audio('static/audio/module_2/shut_down.wav');
                shutdown_audio.volume = 0.75;
                shutdown_audio.play();

                anime({
                  targets: '#aye_face',
                  opacity: [{
                      value: 0,
                      easing: 'linear'
                    },
                    {
                      value: 1,
                      duration: 200,
                      easing: 'linear'
                    },
                    {
                      value: 0,
                      duration: 400,
                      easing: 'linear'
                    },
                    {
                      value: 1,
                      duration: 200,
                      easing: 'linear'
                    },
                    {
                      value: 0,
                      duration: 1000,
                      easing: 'linear'
                    }
                  ],
                  complete: () => {
                    this.control_panel_active = true;
                  }
                });

                anime({
                  targets: '#aye_head_1',
                  fill: '#000000',
                  easing: 'linear'
                });

                anime({
                  targets: '#ria',
                  scaleX: -1,
                  duration: 1,
                  easing: 'linear'
                });

                anime({
                  targets: '#ria_right_brow',
                  rotate: '10deg',
                  easing: 'linear'
                });

                anime({
                  targets: '#ria_left_brow',
                  rotate: '-10deg',
                  easing: 'linear'
                });

                anime({
                  targets: '#ria_left_arm_hand',
                  rotate: 0,
                  easing: 'easeOutCubic'
                });

                let ria_arm_tl = anime.timeline();

                ria_arm_tl.add({
                  targets: '#ria_right_arm',
                  rotate: '-20deg',
                  easing: 'easeOutCubic',
                  duration: 500
                }).add({
                  targets: '#ria_right_arm_hand',
                  rotate: '-45deg',
                  easing: 'easeOutCubic',
                  offset: '-=300',
                  complete: () => {
                    this.control_panel_active = true;
                  }
                });
              }, 3500)
              break;
            case 22:
              this.control_panel_active = true;
              break;
            case 23:
              let aye_push_sound = new Audio('static/audio/module_2/aye_push.wav');
              aye_push_sound.loop = false;
              let push_interval;
              anime({
                targets: '#ria',
                scaleX: {
                  value: -1,
                  duration: 1
                },
                translateY: [{
                    value: 20
                  },
                  {
                    value: 0
                  },
                  {
                    value: 20,
                    delay: 500
                  },
                  {
                    value: 0
                  },
                  {
                    value: 20,
                    delay: 500
                  },
                  {
                    value: 0
                  },
                  {
                    value: 20,
                    delay: 500
                  },
                  {
                    value: 0
                  },
                  {
                    value: 20,
                    delay: 500
                  },
                  {
                    value: 0
                  }
                ],
                translateX: [{
                    value: 80
                  },
                  {
                    value: 160,
                    delay: 500
                  },
                  {
                    value: 240,
                    delay: 500
                  },
                  {
                    value: 320,
                    delay: 500
                  },
                  {
                    value: 400,
                    delay: 500
                  }
                ],
                easing: 'linear',
                duration: 2000,
                begin() {

                  aye_push_sound.play();
                  push_interval = setInterval(() => {
                    aye_push_sound.play();
                  }, 1000);
                }
              });

              anime({
                targets: '#aye',
                translateX: [{
                    value: -80
                  },
                  {
                    value: -160,
                    delay: 500
                  },
                  {
                    value: -240,
                    delay: 500
                  },
                  {
                    value: -320,
                    delay: 500
                  },
                  {
                    value: -400,
                    delay: 500
                  }
                ],
                easing: 'linear',
                duration: 2000,
                complete: () => {

                  timeline.add({
                      targets: '.dad',
                      translateY: [{
                          value: '5px'
                        },
                        {
                          value: '0'
                        },
                        {
                          value: '5px'
                        },
                        {
                          value: '0'
                        },
                        {
                          value: '5px'
                        },
                        {
                          value: '0'
                        }
                      ],
                      // translateX: '-125%',
                      translateX: '-180px',
                      duration: 2000,
                      easing: 'linear'
                    }).add({
                      targets: '#dad_speech_bubble',
                      scale: 1.2,
                      opacity: 1,
                      offset: '-=700'
                    })
                    .add({
                      targets: '#dad_left_arm',
                      rotate: ['-70deg', '0deg'],
                      duration: 1500
                    })
                    .add({
                      targets: '#dad_speech_bubble',
                      opacity: 0,
                      easing: 'linear',
                      duration: 500
                    })
                    .add({
                      targets: '#dad_left_arm',
                      rotate: ['0deg', '-70deg'],
                      duration: 1500,
                      offset: '-=500'
                    }).add({
                      targets: '#mom_speech_bubble',
                      scale: 1.2,
                      opacity: [{
                          value: 1,
                          easing: 'linear'
                        },
                        {
                          value: 0,
                          delay: 500,
                          easing: 'linear'
                        }
                      ],
                      offset: '-=700'
                    }).add({
                      targets: '#crash, #bang',
                      opacity: [{
                          value: 1
                        },
                        {
                          value: 0
                        }
                      ],
                      easing: 'linear',
                      scale: 1.25,
                      duration: 1500,
                      delay(el, i) {
                        return i * 500;
                      }
                    }).add({
                      targets: '#dylan_shadow',
                      translateY: [{
                          value: 10
                        },
                        {
                          value: 0
                        },
                        {
                          value: 10
                        },
                        {
                          value: 0
                        },
                        {
                          value: 10
                        },
                        {
                          value: 0
                        },
                        {
                          value: 10
                        },
                        {
                          value: 0
                        }
                      ],
                      translateX: [0, 300],
                      offset: '-=500',
                      opacity: [{
                          value: 1,
                          duration: 1000
                        },
                        {
                          value: 0,
                          duration: 300,
                          delay: 1700
                        }
                      ],
                      duration: 3000,
                      easing: 'linear'
                    }).add({
                      targets: '#dylan',
                      translateY: [{
                          value: -10
                        },
                        {
                          value: 0
                        },
                        {
                          value: -10
                        },
                        {
                          value: 0
                        }
                      ],
                      translateX: [-150, 0],
                      opacity: {
                        value: 1,
                        duration: 500
                      },
                      duration: 1500,
                      easing: 'linear',
                      complete: () => {
                        let door_shut_sound = new Audio('static/audio/module_2/door_shut.wav');
                        door_shut_sound.play();
                        this.control_panel_active = true;
                      }
                    });
                  clearInterval(push_interval);
                }
              });
              break;
            case 24:
              this.pins_active = true;
              anime({
                targets: '.pin',
                translateY: [-20, 0],
                opacity: {
                  value: 1,
                  easing: 'linear',
                  duration: 300
                },
                elasticity: 750
              });
              break;
            case 25:
              this.aye_state = ['unsure', 'orange'];
              this.ria_frown = false;

              anime({
                targets: '.pin',
                opacity: 0,
                easing: 'linear',
                complete: () => {
                  this.pins_active = false;
                  this.selected_pin = null;
                }
              });

              anime({
                targets: '#ria',
                translateY: [{
                    value: '20px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '20px'
                  },
                  {
                    value: '0'
                  }
                ],
                left: ['-20%', '10%'],
                easing: 'linear',
                duration: 2000
              });

              anime({
                targets: '#ria_right_arm, #ria_right_arm_hand, #ria_right_brow, #ria_left_brow',
                rotate: '0deg',
                duration: 1,
                complete: () => {
                  console.log('unrotated brows')
                }
              });

              anime({
                targets: '#aye_face',
                opacity: 1
              });

              anime({
                targets: '#aye_head_1',
                fill: '#777'
              });

              anime({
                targets: '#aye',
                translateY: [{
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  }
                ],
                left: ['-20%', '0'],
                easing: 'linear',
                duration: 2000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 26:
              anime({
                targets: '#ria_left_arm_hand',
                rotate: '-45deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 27:
              this.ria_head_flip = true;
              this.control_panel_active = true;
              break;
            case 28:
              this.aye_state = ['neutral', 'yellow'];
              anime({
                targets: '#aye_left_arm_hand',
                rotate: '-120deg',
                easing: 'easeOutCubic',
                delay: 1000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: 0,
                easing: 'easeOutCubic'
              });
              break;
            case 29:
              anime({
                targets: '#aye_left_arm_hand',
                rotate: 0,
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#ria_left_arm_hand',
                rotate: '-45deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 30:
              this.ria_head_flip = false;
              this.control_panel_active = true;
              break;
            case 31:
              this.modal_active = true;
              this.control_panel_active = true;
              break;
            case 32:
              this.aye_state = ['smile', 'green'];
              this.control_panel_active = true;
              break;
            case 33:
              anime({
                targets: '#ria_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#ria',
                translateY: 20,
                easing: 'linear',
                direction: 'alternate',
                duration: 500,
                loop: true
              });

              anime({
                targets: '#aye',
                translateY: 10,
                easing: 'linear',
                direction: 'alternate',
                duration: 650, // 500,
                loop: true
              });

              anime({
                targets: this.car_audio,
                volume: 0,
                easing: 'linear',
                duration: 8000,
                complete: () => {
                  delete this.car_audio;
                }
              })

              anime({
                targets: '#town',
                translateX: '-75%',
                duration: 8000,
                easing: 'linear',
                complete: () => {
                  anime.remove('#ria, #aye');
                  this.control_panel_active = true;
                }
              });
              break;
            case 34:
              anime({
                targets: '#ria_left_arm_hand',
                rotate: [{
                    value: '-45deg'
                  },
                  {
                    value: 0,
                    delay: 500
                  }
                ],
                easing: 'easeOutCubic',
                duration: 2000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 35:
              anime({
                targets: '#aye_left_arm_hand',
                rotate: [{
                    value: '-120deg'
                  },
                  {
                    value: 0,
                    delay: 500
                  }
                ],
                easing: 'easeOutCubic',
                duration: 2000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 36:
              let ria_array = [];
              let aye_array = [];
              let check = true;
              for (let i = 0; i <= 10; i++) {
                if (check) {
                  let ria_temp = {
                    value: 20
                  }
                  let aye_temp = {
                    value: 10
                  }
                  ria_array.push(ria_temp);
                  aye_array.push(aye_temp);
                  check = false;
                } else {
                  let temp = {
                    value: 0
                  }
                  ria_array.push(temp);
                  aye_array.push(temp);
                  check = true;
                }
              }

              anime({
                targets: '#ria',
                translateY: ria_array,
                left: ['10%', '105%'],
                easing: 'linear',
                duration: 5000,
                begin: () => {
                  this.lab_ready_state.doors_active = true;
                }
              });

              anime({
                targets: '#aye',
                translateY: aye_array,
                left: ['0%', '105%'],
                easing: 'linear',
                duration: 5000,
                complete: () => {
                  this.school_doors = true;
                  anime({
                    targets: '#school_doors #left_door',
                    translateX: ['-100%', '0'],
                    opacity: {
                      value: 1,
                      duration: 200
                    },
                    easing: 'easeOutQuart',
                    duration: 2000,
                    begin: () => {
                      let door_sound = new Audio('static/audio/module_1/door_open.wav');
                      door_sound.play();
                    }
                  });

                  anime({
                    targets: '#school_doors #right_door',
                    translateX: ['100%', '0'],
                    opacity: {
                      value: 1,
                      duration: 200
                    },
                    duration: 2000,
                    easing: 'easeOutQuart',
                    complete: () => {
                      anime.remove(
                        '#fingerprint_1, #fingerprint_2, #fingerprint_3, #fingerprint_4, #fingerprint_5');
                      this.module_complete = true;
                    }
                  });
                }
              });
              break;

          }
        }
      },
      ria_speech(count, delay) {
        let temp = count - 1;
        if (temp >= 0) {
          this.ria_speaking = true;
          setTimeout(() => {
            this.ria_speaking = false;
            setTimeout(() => {
              this.ria_speech(temp, delay);
            }, delay);
          }, delay);
        }
      },
      players_idle(player) {
        let player_state = this['player' + player + '_state'];
        player_state.blinking = true;
        player_state.talking = true;

        setTimeout(() => {
          player_state.blinking = false;
        }, 300);

        setTimeout(() => {
          this.player_speech(4, player);
        }, 1000);

        switch (player) {
          case 1:

            anime({
              targets: '#player1_left_arm_hand',
              rotate: '-20deg',
              easing: 'linear'
            });

            setTimeout(() => {
              anime({
                targets: '#player1_left_arm_hand',
                rotate: 0,
                easing: 'linear'
              });
            }, 2000);
            break;
          case 2:
            anime({
              targets: '#player2_right_arm_hand',
              rotate: '60deg',
              easing: 'linear',
              duration: 500
            });

            setTimeout(() => {
              anime({
                targets: '#player2_right_arm_hand',
                rotate: 0,
                easing: 'linear'
              });
            }, 2000);
            break;
          case 3:
            anime({
              targets: '#player3_left_arm_hand',
              rotate: '45deg',
              easing: 'linear',
              duration: 500
            });

            setTimeout(() => {
              anime({
                targets: '#player3_left_arm_hand',
                rotate: 0,
                easing: 'linear'
              });
            }, 2000);
            break;
        }
      },
      player_speech(count, player) {
        let player_state = this['player' + player + '_state'];
        let temp = count - 1;
        if (temp >= 0) {
          player_state.talking = true;
          setTimeout(() => {
            player_state.talking = false;
            setTimeout(() => {
              this.player_speech(temp, player);
            }, 300);
          }, 300);
        }
      },
      player2_head() {
        this.player2_state.direction = this.player2_state.direction == 'left' ? 'right' : 'left';
      },
      pin_open(pin) {
        this.modal_active = true;
        this.selected_pin = pin;
        this.control_panel_active = true;
      },
      modal_close() {
        this.modal_active = false;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// module_2.vue?2e103898